/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RecurrenceSchedule } from './RecurrenceSchedule';
import {
    RecurrenceScheduleFromJSON,
    RecurrenceScheduleFromJSONTyped,
    RecurrenceScheduleToJSON,
    RecurrenceScheduleToJSONTyped,
} from './RecurrenceSchedule';

/**
 * 
 * @export
 * @interface CreateCompetitionBodyRecurrence
 */
export interface CreateCompetitionBodyRecurrence {
    /**
     * 
     * @type {RecurrenceSchedule}
     * @memberof CreateCompetitionBodyRecurrence
     */
    schedule?: RecurrenceSchedule;
    /**
     * 
     * @type {string}
     * @memberof CreateCompetitionBodyRecurrence
     */
    dayOfWeek?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompetitionBodyRecurrence
     */
    time?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompetitionBodyRecurrence
     */
    cronExpression?: string;
}



/**
 * Check if a given object implements the CreateCompetitionBodyRecurrence interface.
 */
export function instanceOfCreateCompetitionBodyRecurrence(value: object): value is CreateCompetitionBodyRecurrence {
    return true;
}

export function CreateCompetitionBodyRecurrenceFromJSON(json: any): CreateCompetitionBodyRecurrence {
    return CreateCompetitionBodyRecurrenceFromJSONTyped(json, false);
}

export function CreateCompetitionBodyRecurrenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCompetitionBodyRecurrence {
    if (json == null) {
        return json;
    }
    return {
        
        'schedule': json['schedule'] == null ? undefined : RecurrenceScheduleFromJSON(json['schedule']),
        'dayOfWeek': json['dayOfWeek'] == null ? undefined : json['dayOfWeek'],
        'time': json['time'] == null ? undefined : json['time'],
        'cronExpression': json['cronExpression'] == null ? undefined : json['cronExpression'],
    };
}

export function CreateCompetitionBodyRecurrenceToJSON(json: any): CreateCompetitionBodyRecurrence {
    return CreateCompetitionBodyRecurrenceToJSONTyped(json, false);
}

export function CreateCompetitionBodyRecurrenceToJSONTyped(value?: CreateCompetitionBodyRecurrence | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'schedule': RecurrenceScheduleToJSON(value['schedule']),
        'dayOfWeek': value['dayOfWeek'],
        'time': value['time'],
        'cronExpression': value['cronExpression'],
    };
}

